/* eslint-disable react-hooks/exhaustive-deps */
import {
	List,
	ListItem,
	VStack,
	Menu,
	MenuButton,
	MenuList,
	Button,
	MenuOptionGroup,
	MenuItemOption,
	Box,
	HStack,
} from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useAuthContext } from '../../../context/auth.context'
import {
	useRemoveParticipant,
	useSetParticipantAsOwner,
	useSetParticipantAsLead,
} from '../../../hooks/activity.hooks'
import { sharedConst } from '../../../utils/action.constant'
import { getMessageUniqueId } from '../../../utils/common.util'
import { formatDueDateForTimelineCurrDate } from '../../../utils/date.utils'
import { useSharedContext } from '../../../context/shared.context'
import { useLoadActivityDetails } from '../../../hooks/activity.hooks'
import { ActivityUsersRow } from '../../../components/globalComponents/activityUsersRow'
import { BiChevronDown } from 'react-icons/bi'
import { useLanguageContext } from '../../../context/locale.context'

const ParticipantsList = ({
	activity,
	search_string = '',
	onSetReload,
	participantData,
	participantPayload,
}) => {
	const {
		state: { authData },
	} = useAuthContext()
	const { dispatch } = useSharedContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const { mutate: setOwnerMutate } = useSetParticipantAsOwner()
	const { mutate: setLeadMutate } = useSetParticipantAsLead()
	const { mutate: removeMutate } = useRemoveParticipant()
	const { mutate: mutateLoadActivity } = useLoadActivityDetails()
	const [selectedType, setSelectedType] = useState(0)

	const {
		activity_id,
		activity_master_data,
		activity_creator_asset_id: creator,
		activity_lead_asset_id: lead,
	} = activity

	const {
		operating_asset_first_name: setterName,
		asset_id: loggedInuserId,
		asset_flag_super_admin,
	} = authData

	const loadDetails = useCallback(activity => {
		mutateLoadActivity(
			{
				activity_id: activity.activity_id,
				activity_type_id: activity.activity_type_id,
			},
			{
				onSuccess: async details => {
					const isLead = loggedInuserId === details.activity_lead_asset_id
					const isOwner = asset_flag_super_admin
					dispatch({
						type: sharedConst.ACTVITY_SELECTED,
						payload: {
							...details,
							isLead,
							isOwner,
						},
					})
				},
				onError: async err => {
					console.log('Err occurred', err)
				},
			}
		)
	})

	const removeParticipant = useCallback(participant => {
		removeMutate(
			{
				activity_id,
				activity_participant_collection: JSON.stringify([
					{
						...participant,
						access_role_id: 0,
						message_unique_id: getMessageUniqueId(),
					},
				]),
			},
			{
				onSuccess: async data => {
					onSetReload()
				},
				onError: async error => {
					console.log('remove error', error)
				},
			}
		)
	})

	const setOwner = useCallback(
		({ asset_id, operating_asset_first_name: pName }, owner = true) => {
			let content = owner
				? `${setterName} set ${pName} as owner @ ${formatDueDateForTimelineCurrDate()}`
				: `${setterName} revoke ownership ${pName} @ ${formatDueDateForTimelineCurrDate()}`
			setOwnerMutate(
				{
					owner_flag: owner ? 1 : 0,
					target_asset_id: asset_id,
					activity_id,
					content,
				},
				{
					onSuccess: async data => {
						onSetReload()
					},
					onError: async error => {
						console.log('remove error', error)
					},
				}
			)
		}
	)

	const setLead = useCallback(({ asset_id }) => {
		setLeadMutate(
			{ lead_asset_id: asset_id, activity_id },
			{
				onSuccess: async data => {
					onSetReload()
					loadDetails(activity)
					setTimeout(() => {
						dispatch({
							type: sharedConst.REFRESH_LISTING,
						})
					}, 1000)
				},
				onError: async error => {
					// console.log('error on set lead', error)
				},
			}
		)
	})
	const [selectedUsers, setSelectedUsers] = useState([])
	useEffect(() => {
		setSelectedUsers(participantPayload?.activeInternals)
	}, [participantPayload])
	const participantSelect = id => {
		setSelectedType(id)
		let participantUsers = ''
		if (id === '1') {
			participantUsers = participantPayload?.activeInternals?.filter(
				item => item.asset_id === lead
			)
		} else if (id === '2') {
			participantUsers = participantPayload?.activeInternals?.filter(
				item => item.asset_flag_is_owner === 1
			)
		} else if (id === '3') {
			participantUsers = participantPayload?.activeInternals?.filter(
				item =>
					item.asset_id !== creator &&
					item.asset_id !== lead &&
					item.asset_flag_is_owner !== 1
			)
		} else {
			participantUsers = participantPayload?.activeInternals
		}

		setSelectedUsers(participantUsers)
	}

	return (
		<VStack h='100%' w='100%' m='0px' p='0px'>
			<HStack spacing={2} justifyContent='flex-end' width='90%'>
				<Menu closeOnSelect={true}>
					<MenuButton
						as={Button}
						minWidth='170px'
						border='1px solid #009B76'
						borderRadius='17px'
						bg='#FFFFFF'
						boxShadow={' 0px 5px 10px rgba(0, 0, 0, 0.25)'}
						rightIcon={<BiChevronDown color='green' size={'20'} />}
						fontSize='14px'
						fontWeight='500'
						color={'#000000'}
						_hover={{
							bg: '#FFFFFF',
						}}
						_active={{
							bg: '#FFFFFF',
						}}
					>
						{locale['Participation type']}
					</MenuButton>
					<MenuList
						minWidth='170px'
						border='1px solid #009B76'
						borderRadius='10px'
						bg='#FFFFFF'
						boxShadow={' 0px 5px 10px rgba(0, 0, 0, 0.25)'}
						color='brand.700'
						fontSize={'14px'}
						fontWeight='500'
					>
						<MenuOptionGroup
							defaultValue='0'
							type='radio'
							onChange={event => participantSelect(event)}
						>
							<MenuItemOption value='0' borderBottom={'1px solid #E1E1E1'}>
								{locale['All']}
							</MenuItemOption>
							<MenuItemOption value='1' borderBottom={'1px solid #E1E1E1'}>
								{locale['Lead']}
							</MenuItemOption>
							<MenuItemOption value='2' borderBottom={'1px solid #E1E1E1'}>
								{locale['Owner']}
							</MenuItemOption>
							<MenuItemOption value='3' borderBottom={'1px solid #E1E1E1'}>
								{locale['Participant']}
							</MenuItemOption>
						</MenuOptionGroup>
					</MenuList>
				</Menu>
			</HStack>
			<List
				px={3}
				w='100%'
				spacing={2}
				h='100%'
				overflowY='scroll'
				overflowX='hidden'
			>
				{(selectedUsers || [])
					.filter(u => {
						if (!!search_string) {
							return u.operating_asset_first_name
								.toLowerCase()
								.includes(search_string.toLowerCase())
						}
						return u
					})
					.map(u => {
						return (
							<>
								<ListItem bg='white' key={u.asset_id}>
									<ActivityUsersRow
										userType='participant'
										user={u}
										participantData={participantData}
										setOwner={setOwner}
										setLead={setLead}
										removeParticipant={removeParticipant}
										selectedType={selectedType}
									/>
								</ListItem>
							</>
						)
					})}
			</List>
		</VStack>
	)
}

export default ParticipantsList
